export default {
    COMPLETE_LESSON: "COMPLETE_LESSON",
    COMPLETE_LESSON_ERROR: "COMPLETE_LESSON_ERROR",
    COMPLETE_LESSON_SUCCESS: "COMPLETE_LESSON_SUCCESS",

    SHOW_MODAL_SUCCESS_CERTIFICATE: "SHOW_MODAL_SUCCESS_CERTIFICATE",
    HIDE_MODAL_SUCCESS_CERTIFICATE: "HIDE_MODAL_SUCCESS_CERTIFICATE",
}